import { EnumArticleType } from "../enum/enum-article-type";
import { EnumProductType } from "../enum/enum-product-type";
import { PriceList } from "./pricelist.model";

export abstract class ProductV2 {
        id: number;
        priceList: PriceList;
        serviceLine: string;
        productLine: string;
        type: EnumArticleType;
        productType: EnumProductType;
        family: string;
        subfamily: string;
        code: string;
        label: string;
        serviceTimePerDevice: string;
        installationTimePerDevice: string;
        isCmc: boolean;
        ppe: boolean;
        grossMarginRate: string;
        washRate?: string;
        washLifetime?: string;

        public get productDetails(): Record<string, any> {
                return {
                        'family': this.family,
                        "machineInstallationTimeInSeconds": this.installationTimePerDevice,
                        "machineServiceTimeInSeconds": this.serviceTimePerDevice,
                        "subFamily": this.subfamily
                }
        }
}
